import FormPageFake, {
  THEMES as FAKE_THEMES,
} from '@/components/fakes/formPagesFake';

function FormMiMovistarFake() {
  return (
    <FormPageFake
      formTemplateFakes={[
        {
          theme: FAKE_THEMES.textList,
          fakeLength: 1,
        },
      ]}
    />
  );
}
export default FormMiMovistarFake;
